import 'slick-carousel';

export class Members {
	constructor() {
		this.container = document.querySelectorAll('.about-teamCategoryItem');
	}

	init() {
		this.container.forEach((container) => {
			$(container)
				.find('.about-teamMembers')
				.slick({
					slidesToShow: 3,
					slidesToScroll: 1,
					infinite: false,
					dots: false,
					prevArrow: $(container).find('.prev'),
					nextArrow: $(container).find('.next'),
					responsive: [
						{
							breakpoint: 600,
							settings: {
								slidesToShow: 1,
							},
						},
						{
							breakpoint: 768,
							settings: {
								slidesToShow: 2,
								slidesToScroll: 1,
							},
						},
					],
				});
		});
	}
}
